import * as Types from '../../@types/graphql-types';

import gql from 'graphql-tag';
export type GetFinalClickoutUrlMutationVariables = Types.Exact<{
	input: Types.Scalars['String']['input'];
	uct2input?: Types.InputMaybe<Types.Uct2Input>;
}>;

export type GetFinalClickoutUrlMutation = {
	__typename?: 'Mutation';
	getFinalClickoutUrl: { __typename?: 'GetFinalClickoutUrlPayload'; url: string };
};

export const GetFinalClickoutUrlDocument = gql`
	mutation GetFinalClickoutUrl($input: String!, $uct2input: Uct2Input) {
		getFinalClickoutUrl(input: $input, uct2input: $uct2input) {
			url
		}
	}
`;
